import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { IngredientsServices } from '../../../ingredients/services';

/**
 * Generated class for the PhotoIngredientPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'photo-ingredient',
  templateUrl: 'photo-ingredient.html',
})
export class PhotoIngredientPage {
  @Input() photo_width:string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ingredientsServices: IngredientsServices) {
  }


  stylePhoto() {
    let styles = {
      'width': this.photo_width+' !important;',
    };

    return styles;

  }


}



// WEBPACK FOOTER //
// ./src/pages/components/photo/photo-ingredient/photo-ingredient.ts